import getPeople from '../../data_management/getPeople'
import getWorkspaces from '../../data_management/getWorkspaces'
import EntityHelper from '../../util/entity_helper'
import buildPathForEntity from '../../util/build_path_for_entity'
import { sortByName } from '../../data_management/sorters/sort_by_name';
import { sortByCreatedAtDesc } from '../../data_management/sorters/sort_by_created_at_desc';
import { Loader } from '../common/loader';

class Workspaces {
  availableSortMethods = {
    'Name': sortByName,
    'Date': sortByCreatedAtDesc
  };
  sortMethod = 'Name';

  helper = new EntityHelper("members");
  allWorkspaces = [];
  filterString = '';

  constructor($scope, $element, $location, dataService, initialDataInteractor,
              eventsService, workspaceInteractor, localize) {
    this.$scope = $scope;
    this.$element = $element;
    this.$location = $location;
    this.dataService = dataService;
    this.initialDataInteractor = initialDataInteractor;
    this.eventsService = eventsService;
    this.workspaceInteractor = workspaceInteractor;
    this.localize = localize;
  }


  $onInit() {
    this.loader = new Loader(this.$element[0]);
    this.newWorkspaceName = '';
    this.initialDataInteractor.ensureInitializedSession().then(() => {
      this.allWorkspaces = getWorkspaces(this.initialDataInteractor).sort(sortByName);
      this.people = getPeople(this.initialDataInteractor);
      if (this.member) filterWorkspacesByMember();
      this.loader.remove();
      this.applyWorkspacesFilter();
      this.$scope.$digest();
    });
  };

  $onChanges() {
    this.applyWorkspacesFilter();
  };

  sortMethodNames() {
    return Object.keys(this.availableSortMethods);
  };

  peopleSummary(workspace) {
    return this.helper.itemSummaryString(workspace.people, member => member.name);
  };

  getEntityName(workspace) {
    return workspace.name;
  };

  createNewWorkspace() {
    let members = this.member ? [ this.member.id ] : [];

    this.workspaceInteractor.createWorkspace({
      'name': this.newWorkspaceName,
      'memberIds': members
    }).then(data => this.$scope.$evalAsync(() => this.$location.path('/workspace/' + data.id)));
  };

  isCreateWorkspaceDisabled() {
    return this.newWorkspaceName.length === 0;
  };

  clickedName(workspace) {
    this.$scope.$evalAsync(() => {
      let path = buildPathForEntity('workspace', workspace.id);
      this.$location.path(path)
    });
  };

  archive(workspace){
    return this.workspaceInteractor.archive(workspace)
      .then(() => {
        this.eventsService.publishSystemMessage(this.localize.string('workspaces', 'workspace_archived'));
        this.workspaces = getWorkspaces(this.initialDataInteractor);
        this.$scope.$digest();
      }).catch(err => console.log(err.message));
  };

  applyWorkspacesFilter() {
    this.workspaces = this.allWorkspaces.slice(); // Clone
    if (this.member) this.workspaces = this.workspaces.filter(workspace => workspace.people.includes(this.member.id));
    if (!this.filterString.isEmpty) this.workspaces = this.workspaces.filter(workspace => workspace.name.toUpperCase().indexOf(this.filterString.toUpperCase()) !== -1);
    this.workspaces = this.workspaces.sort(this.availableSortMethods[this.sortMethod]);
  };

  isWorkspaceOwned(workspace) {
    return this.workspaceInteractor.isWorkspaceOwner(workspace);
  };

  relationToWorkspace(workspace) {
    return this.isWorkspaceOwned(workspace) ? this.localize.string('workspaces', 'is_owner') : this.localize.string('workspaces', 'is_member');
  };

  workspaceClasses(workspace) {
    return ['clickable', this.isWorkspaceOwned(workspace) ? 'owner' : 'participant'];
  };

}

export default {
  name: 'workspaces',
  obj: {
    controller: Workspaces,
    templateUrl: 'components/workspaces.html',
    bindings: {
      member: '<'
    }
  },
  deps: []
}